import { Col, Row } from "react-grid-system";
import { useQuery } from "react-query";
import { getUser, setUserActive, UserType } from "../../../api/admin/user";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { SFormFooter } from "../../../styles/ChangePassword";
import { Button } from "../../Button";
import { QueryLoader } from "../../Loader";
import { useState } from "react";

type UserActivationProps = { userId: number; refetchUsers: () => void; closeModal: () => void };

// Users are never deleted: an organization admin deactivates (or reactivates) them
export const UserActivation = (props: UserActivationProps) => {
	const { userId, refetchUsers, closeModal } = props;
	const { axiosPrivate } = useAxiosPrivate();

	const { isLoading, isError, error, data } = useQuery<UserType>(["user", userId], () => getUser(axiosPrivate, userId));

	const [isSubmitting, setIsSubmitting] = useState(false);

	const handleConfirm = async (active: boolean) => {
		setIsSubmitting(true);
		const res = await setUserActive({ axiosPrivate, userId, active });
		if (res?.status === 200) {
			refetchUsers();
			closeModal();
		}
		setIsSubmitting(false);
	};

	if (isLoading) {
		return <QueryLoader />;
	}

	if (isError) {
		console.error(error);
		return <>Something went wrong. Please try again.</>;
	}

	if (!data) {
		return (
			<>
				<Row>
					<Col>
						<h3>User does not exist</h3>
					</Col>
				</Row>
				<Row>
					<Col>
						<SFormFooter>
							<Button onClick={() => closeModal()}>Close</Button>
						</SFormFooter>
					</Col>
				</Row>
			</>
		);
	}

	const activate = !data.active;

	return (
		<>
			<Row>
				<Col>
					<h3>
						{activate ? "Reactivate" : "Deactivate"} {data?.firstName} {data?.lastName}
					</h3>
				</Col>
			</Row>
			<Row style={{ marginTop: "1rem" }}>
				<Col>
					<p>
						{activate
							? "Are you sure you want to reactivate this user? The user will be able to log in again."
							: "Are you sure you want to deactivate this user? The user will no longer be able to log in, but all their data is kept."}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<SFormFooter>
						<Button onClick={() => closeModal()}>Cancel</Button>
						<Button type="submit" onClick={() => handleConfirm(activate)} disabled={isSubmitting}>
							{activate ? "Reactivate" : "Deactivate"}
						</Button>
					</SFormFooter>
				</Col>
			</Row>
		</>
	);
};
